import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'real'
})
export class RealPipe implements PipeTransform {
  transform(value: number | string): string {
    const numero = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numero)) return 'R$ 0,00';

    return numero.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }
}